// WHAT CAN BE CHANGED?
// Put the desired content into the #message-div
// Make changes to each of the components accordingly

<template>
    <div id="message" class="page">
        <ChatPermission :userData="userData" v-if="!userData[0].permissionGranted"/>
        <Chatbox :userData="userData" :chatboxMessages="chatboxMessages" v-if="userData[0].permissionGranted"/>
        <ChatInput :userData="userData" :chatboxMessages="chatboxMessages" v-if="userData[0].permissionGranted"/>
    </div>
</template>

<script>
import ChatPermission from "@/components/ChatPermission.vue";
import Chatbox from '@/components/Chatbox.vue';
import ChatInput from "@/components/ChatInput.vue"

export default {
    name: "Message",
    components: {
        ChatPermission,
        Chatbox,
        ChatInput,
    },
    created() {
        this.userData[0].uid = JSON.parse(localStorage.getItem("uid"));
        this.userData[0].username = JSON.parse(localStorage.getItem("username"));

        this.chatboxMessages = JSON.parse(sessionStorage.getItem("data"));
        if(this.chatboxMessages == null) {
            sessionStorage.setItem("data", JSON.stringify([]));
        }

        this.userData[0].permissionGranted = JSON.parse(localStorage.getItem("permissionGranted"));
        this.chatboxMessages = JSON.parse(sessionStorage.getItem("data"));
        if (this.userData[0].uid == null) {
            this.userData[0].uid = this.generateUserID(16);
            localStorage.setItem("uid", JSON.stringify(this.userData[0].uid));
        }
    },
    data() {
        return {
            userData: [
                { 
                    uid: null, 
                    username: null, 
                    phone: null,
                    permissionGranted: false
                },
            ],
            chatboxMessages: [],
        }
    },
    methods: {
        generateUserID(size) {
            return [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('')
        },
    }
};
</script>

<style lang="scss" scoped>
#message {
   
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #message {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #message {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #message {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #message {

    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #message {
       
    }
}
</style>